import { render, staticRenderFns } from "./participant-document-detail.vue?vue&type=template&id=3ea12c23&scoped=true&"
import script from "./participant-document-detail.vue?vue&type=script&lang=js&"
export * from "./participant-document-detail.vue?vue&type=script&lang=js&"
import style0 from "../../../../public/static/fonts.scss?vue&type=style&index=0&id=3ea12c23&scoped=true&lang=scss&"
import style1 from "./participant-document-detail.vue?vue&type=style&index=1&id=3ea12c23&scoped=true&lang=scss&"
import style2 from "@/assets/dot-streaching-loader.scss?vue&type=style&index=2&id=3ea12c23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea12c23",
  null
  
)

component.options.__file = "participant-document-detail.vue"
export default component.exports